module.exports = __webpack_public_path__ + "img/tpc-21.b3aef227.jpg";